function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-HD",
  transform: "translate(-503.000000, -292.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(503.000000, 292.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "to-fill",
  id: "Rectangle",
  fill: "#220BAB",
  x: 0,
  y: 0,
  width: 470,
  height: 470,
  rx: 20
}), /*#__PURE__*/React.createElement("text", {
  className: "to-color",
  id: "I-speak-English-Fren",
  fontFamily: "AvenirNext-Bold, Avenir Next",
  fontSize: 64,
  fontWeight: "bold",
  "line-spacing": 70,
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 85,
  y: 159
}, "I speak"), /*#__PURE__*/React.createElement("tspan", {
  x: 85,
  y: 229
}, "English"), /*#__PURE__*/React.createElement("tspan", {
  x: 85,
  y: 299
}, "French"), /*#__PURE__*/React.createElement("tspan", {
  x: 85,
  y: 369
}, "Allemand")), /*#__PURE__*/React.createElement("text", {
  id: "Languages-level",
  fontFamily: "AvenirNext-Medium, Avenir Next",
  fontSize: 18,
  fontWeight: 400,
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 270,
  y: 441
}, "Languages level")), /*#__PURE__*/React.createElement("g", {
  id: "arrow-right",
  transform: "translate(423.000000, 428.000000)",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,8 L16,8",
  id: "Path"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "8 0 16 8 8 16"
})))));

var SvgLanguages = function SvgLanguages(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "#fff",
    width: "470px",
    height: "470px",
    viewBox: "0 0 470 470",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLanguages, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/languages.cf4e6acc.svg";
export { ForwardRef as ReactComponent };